// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pm-timesheet-page {
  padding: 1.5rem 1.75rem;
}

.pm-timesheet-page .page-header {
  margin-bottom: 1.25rem;
}

.pm-timesheet-page .card {
  border-color: #e7edf3;
  box-shadow: 0 8px 22px rgba(16, 24, 40, 0.04);
}

.pm-timesheet-page .card-header {
  align-items: flex-start;
  min-height: 64px;
}

.pm-timesheet-page .card-subtitle {
  font-size: 0.875rem;
  line-height: 1.35;
}

.pm-timesheet-filter-card .form-label {
  color: #667085;
  font-weight: 600;
  margin-bottom: 0.35rem;
}

.pm-timesheet-helper {
  font-size: 0.8125rem;
}

.pm-timesheet-micro {
  font-size: 0.75rem;
}

.pm-timesheet-icon {
  align-items: center;
  border-radius: 8px;
  display: inline-flex;
  flex-shrink: 0;
  height: 44px;
  justify-content: center;
  width: 44px;
}

.pm-timesheet-primary {
  background: rgba(31, 143, 152, 0.12);
  color: #1f8f98;
}

.pm-timesheet-success {
  background: rgba(0, 166, 121, 0.12);
  color: #00a679;
}

.pm-timesheet-warning {
  background: rgba(245, 159, 0, 0.14);
  color: #c87b00;
}

.pm-timesheet-info {
  background: rgba(22, 114, 185, 0.12);
  color: #1672b9;
}

.pm-timesheet-empty {
  align-items: center;
  border-top: 1px solid #edf2f7;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 280px;
  padding: 2rem;
  text-align: center;
}

.pm-timesheet-readiness {
  align-items: flex-start;
  background: #f8fafc;
  border: 1px solid #e7edf3;
  border-radius: 8px;
  display: flex;
  gap: 0.75rem;
  padding: 1rem;
}

.pm-timesheet-checklist {
  border: 1px solid #e7edf3;
  border-radius: 8px;
  overflow: hidden;
}

.pm-timesheet-checklist > div {
  align-items: center;
  display: flex;
  gap: 0.6rem;
  padding: 0.75rem 1rem;
}

.pm-timesheet-checklist > div + div {
  border-top: 1px solid #edf2f7;
}

.pm-timesheet-checklist svg {
  color: #1f8f98;
  flex-shrink: 0;
}

.pm-timesheet-error {
  border-color: rgba(245, 159, 0, 0.25);
}

.pm-timesheet-spin {
  animation: pm-timesheet-spin 0.8s linear infinite;
}

.pm-timesheet-table th {
  color: #667085;
  font-size: 0.75rem;
  letter-spacing: 0;
  text-transform: uppercase;
  white-space: nowrap;
}

.pm-timesheet-table td {
  vertical-align: middle;
}

.pm-timesheet-table {
  min-width: 980px;
  width: 980px;
}

.pm-timesheet-note {
  max-width: 220px;
  white-space: normal;
}

@keyframes pm-timesheet-spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

@media (max-width: 767.98px) {
  .pm-timesheet-page {
    padding: 1rem;
  }
}

@media (min-width: 768px) and (max-width: 1199.98px) {
  .pm-timesheet-page {
    padding: 1rem;
  }

  .pm-timesheet-page .page-header .row {
    row-gap: 1rem;
  }

  .pm-timesheet-page .page-header .col-auto {
    flex: 0 0 100%;
    max-width: 100%;
    width: 100%;
  }

  .pm-timesheet-page .btn-list {
    justify-content: flex-start;
  }

  .pm-timesheet-icon {
    height: 40px;
    width: 40px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/PmTimesheet/PmTimesheet.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,eAAe;IACf,WAAW;EACb;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;AACF","sourcesContent":[".pm-timesheet-page {\n  padding: 1.5rem 1.75rem;\n}\n\n.pm-timesheet-page .page-header {\n  margin-bottom: 1.25rem;\n}\n\n.pm-timesheet-page .card {\n  border-color: #e7edf3;\n  box-shadow: 0 8px 22px rgba(16, 24, 40, 0.04);\n}\n\n.pm-timesheet-page .card-header {\n  align-items: flex-start;\n  min-height: 64px;\n}\n\n.pm-timesheet-page .card-subtitle {\n  font-size: 0.875rem;\n  line-height: 1.35;\n}\n\n.pm-timesheet-filter-card .form-label {\n  color: #667085;\n  font-weight: 600;\n  margin-bottom: 0.35rem;\n}\n\n.pm-timesheet-helper {\n  font-size: 0.8125rem;\n}\n\n.pm-timesheet-micro {\n  font-size: 0.75rem;\n}\n\n.pm-timesheet-icon {\n  align-items: center;\n  border-radius: 8px;\n  display: inline-flex;\n  flex-shrink: 0;\n  height: 44px;\n  justify-content: center;\n  width: 44px;\n}\n\n.pm-timesheet-primary {\n  background: rgba(31, 143, 152, 0.12);\n  color: #1f8f98;\n}\n\n.pm-timesheet-success {\n  background: rgba(0, 166, 121, 0.12);\n  color: #00a679;\n}\n\n.pm-timesheet-warning {\n  background: rgba(245, 159, 0, 0.14);\n  color: #c87b00;\n}\n\n.pm-timesheet-info {\n  background: rgba(22, 114, 185, 0.12);\n  color: #1672b9;\n}\n\n.pm-timesheet-empty {\n  align-items: center;\n  border-top: 1px solid #edf2f7;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-height: 280px;\n  padding: 2rem;\n  text-align: center;\n}\n\n.pm-timesheet-readiness {\n  align-items: flex-start;\n  background: #f8fafc;\n  border: 1px solid #e7edf3;\n  border-radius: 8px;\n  display: flex;\n  gap: 0.75rem;\n  padding: 1rem;\n}\n\n.pm-timesheet-checklist {\n  border: 1px solid #e7edf3;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.pm-timesheet-checklist > div {\n  align-items: center;\n  display: flex;\n  gap: 0.6rem;\n  padding: 0.75rem 1rem;\n}\n\n.pm-timesheet-checklist > div + div {\n  border-top: 1px solid #edf2f7;\n}\n\n.pm-timesheet-checklist svg {\n  color: #1f8f98;\n  flex-shrink: 0;\n}\n\n.pm-timesheet-error {\n  border-color: rgba(245, 159, 0, 0.25);\n}\n\n.pm-timesheet-spin {\n  animation: pm-timesheet-spin 0.8s linear infinite;\n}\n\n.pm-timesheet-table th {\n  color: #667085;\n  font-size: 0.75rem;\n  letter-spacing: 0;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.pm-timesheet-table td {\n  vertical-align: middle;\n}\n\n.pm-timesheet-table {\n  min-width: 980px;\n  width: 980px;\n}\n\n.pm-timesheet-note {\n  max-width: 220px;\n  white-space: normal;\n}\n\n@keyframes pm-timesheet-spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n@media (max-width: 767.98px) {\n  .pm-timesheet-page {\n    padding: 1rem;\n  }\n}\n\n@media (min-width: 768px) and (max-width: 1199.98px) {\n  .pm-timesheet-page {\n    padding: 1rem;\n  }\n\n  .pm-timesheet-page .page-header .row {\n    row-gap: 1rem;\n  }\n\n  .pm-timesheet-page .page-header .col-auto {\n    flex: 0 0 100%;\n    max-width: 100%;\n    width: 100%;\n  }\n\n  .pm-timesheet-page .btn-list {\n    justify-content: flex-start;\n  }\n\n  .pm-timesheet-icon {\n    height: 40px;\n    width: 40px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
